import { memo } from "react"
import { Markdown } from "@/features/nira2/ds/Markdown"

interface QaAnswerMarkdownProps {
  content: string
}

export const QaAnswerMarkdown = memo(function QaAnswerMarkdown({ content }: QaAnswerMarkdownProps) {
  return <Markdown className="qa-a">{content}</Markdown>
})
